import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "enquiry",
  "use": "enquiry-usage",
  "viewBox": "0 0 70.46 87.54",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.46 87.54\" id=\"enquiry\"><path d=\"M69.62 74.43a5.21 5.21 0 01.76 1.75 4.71 4.71 0 01-.22 2.52 4.48 4.48 0 01-1.58 2.1l-3.5 2.55a20.49 20.49 0 01-4.21 2.39 23.64 23.64 0 01-4.48 1.37 23.29 23.29 0 01-7.6.22 28 28 0 01-7.63-2.17 35.63 35.63 0 01-7.34-4.34 44.16 44.16 0 01-6.63-6.25c-1.27-1.3-2.64-2.8-4.09-4.49-1.23-1.43-2.66-3.16-4.25-5.21s-3.32-4.31-5.07-6.87-3.19-4.74-4.32-6.67-2-3.53-2.67-4.81A34.92 34.92 0 015 42.65a43.79 43.79 0 01-2.63-6 44.78 44.78 0 01-1.64-6.17A37.46 37.46 0 010 22.59a28.18 28.18 0 011.11-7.41 22.92 22.92 0 013.11-6.55 21.08 21.08 0 015.24-5.3l3.46-2.5a4.57 4.57 0 011.72-.74A4.4 4.4 0 0119.17 2l10.59 15.11a4.45 4.45 0 01.74 1.73 4.64 4.64 0 01-.19 2.58 4.32 4.32 0 01-1.61 2.08l-6.81 4.93A5 5 0 0020 30.9a5.55 5.55 0 00.66 5.1l17.87 25.74a5.16 5.16 0 002.5 2 5.35 5.35 0 004.97-.65l6.83-5a4.5 4.5 0 011.71-.73 4.36 4.36 0 012.49.23 4.47 4.47 0 012 1.61z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/enquiry.svg
// module id = ouEK
// module chunks = 1